import React from "react";
import { HiOutlineMenu } from "react-icons/hi";

const NavToggle = ({ toggled, className }) => {
  return <div className={className}>{<HiOutlineMenu />}</div>;
};

export default NavToggle;
